import { categories } from "@/mocks/categories";

interface ArchiveFilterProps {
  keyword: string;
  onKeywordChange: (value: string) => void;
  activeCategory: string;
  onCategoryChange: (value: string) => void;
  total: number;
}

export default function ArchiveFilter({
  keyword,
  onKeywordChange,
  activeCategory,
  onCategoryChange,
  total,
}: ArchiveFilterProps) {
  const tabs = [{ slug: "all", name: "全部" }, ...categories];

  return (
    <div className="rounded-lg border border-background-800 bg-background-900 p-4 md:p-5">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="relative w-full lg:max-w-sm">
          <i className="ri-search-line pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-sm text-foreground-500" />
          <input
            type="search"
            value={keyword}
            onChange={(event) => onKeywordChange(event.target.value)}
            placeholder="搜索标题、摘要或标签"
            aria-label="搜索档案"
            className="w-full rounded-md border border-background-700 bg-background-950 py-2.5 pl-10 pr-4 text-sm text-foreground-100 placeholder:text-foreground-600 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500/60"
          />
        </div>
        <p className="flex items-center gap-2 text-xs text-foreground-500">
          <i className="ri-list-check-2" /> 共找到 <span className="font-semibold text-primary-300">{total}</span> 篇档案
        </p>
      </div>

      <div className="mt-4 flex flex-wrap gap-2 border-t border-background-800 pt-4">
        {tabs.map((tab) => (
          <button
            key={tab.slug}
            type="button"
            onClick={() => onCategoryChange(tab.slug)}
            className={`whitespace-nowrap rounded-full px-3.5 py-1.5 text-xs transition-colors ${
              activeCategory === tab.slug
                ? "bg-primary-500 text-background-950"
                : "bg-background-800 text-foreground-300 hover:bg-background-700 hover:text-primary-300"
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>
    </div>
  );
}